import modal from "../components/modal";
import LocationMgr from "./map/LocationMgr";
import UserMgr from "../UserMgr";
import {getToken, postData, saveDebug, swapCoords} from "../components/helpers";
import GlobalVars from "../GlobalVars";

class Socket {

    disableConnection = false;
    socket;
    token;
    pingTimeout = false;
    actions = {
        'authorized': function (data) {
            GlobalVars.wsAuthorized = true;
        },
        'showError': function (data) {
            popup.error(data);
        },
        'userMove': function (data) {
            const user = data;
            if (locationMgr)
                locationMgr.userOnMapMgr.setOponent(user);
        },
        'refresh': function (data) {
            popup.warning(__(data));
            setTimeout(() => window.location.reload(), 1000);
        },
        'goMain': function (data) {
            this.disableConnection = true;
            console.log('disableConnection', this.disableConnection, this);
            popup.warning(__(data));
            setTimeout(() => window.location.href = '/', 1000);
        },
        'pageRefresh': function () {
            popup.warning(__('Server restart, refresh in 20 seconds'));
            setTimeout(() => window.location.reload(), 20000);
        },
        'showModal': function (data) {
            modal.add(data.title, data.message, data.modalId, data.data);
        },
        'setBalances': function (data) {
            UserMgr.setBalances(data);
        },
    }


    constructor() {

        this.id = Math.floor(Math.random() * 1000);
        this.onopen = this.onopen.bind(this);
        this.onclose = this.onclose.bind(this);
        this.onmessage = this.onmessage.bind(this);
        this.onerror = this.onerror.bind(this);
        this.ping = this.ping.bind(this);
        this.refreshConnection = this.refreshConnection.bind(this);
        this.forciblyReconnect = this.forciblyReconnect.bind(this);

        for (const [key, value] of Object.entries(this.actions)) {
            this.actions[key] = this.actions[key].bind(this);
        }

    }

    async forciblyReconnect() {
        // await saveDebug("Forcibly Reconnect");
        this.refreshConnection();
    }

    init() {
        setInterval(this.ping, 10000);
        window.addEventListener('pageshow', this.refreshConnection);
        this.connect();
    }

    async refreshConnection(e) {


        // if (true || e && e.persisted) {
        // await saveDebug("Refresh connection " + this.socket?.readyState);
        if (!this.socket || this.socket.readyState !== this.socket.OPEN || GlobalVars.wsConnection == false)
            this.connect();
        else {
            this.disconnect();
        }
        // }
    }

    disconnect() {

        if (this.socket) {
            this.send('close');
            this.socket.close();
        }
    }

    bindAction(name, callback) {
        this.actions[name] = callback;
    }

    async ping() {

        // await saveDebug("Before ping readyState is " + this.socket.readyState);

        if (!this.socket || this.socket.readyState !== 1) {
            this.disconnect();
            this.connect();
            return;
        }

        // await saveDebug("Ping, timeout= " + this.pingTimeout);

        this.send('ping');
        // if (!this.pingTimeout)
        this.pingTimeout = setTimeout(async () => {
            // alert('No pong!')
            // console.log('No pong!');
            // await saveDebug("No pong");

            // await saveDebug("1. Ready state is " + this.socket.readyState);

            // await postData(config.server_url + '/user/refresh-ws');
            this.disconnect();
            await this.connect();

            // await saveDebug("2. Ready state is " + this.socket.readyState);
            // alert('Close ' + this.socket.readyState)
            // Если не закрылось через 5 сек, то закрываем повторно
            // this.hardCloseInterval = setInterval(async () => {
            //
            //         if (this.socket.readyState == this.socket.CLOSING) {
            //
            //             await postData(config.server_url + '/user/refresh-ws');
            //             this.disconnect();
            //
            //         } else {
            //
            //             clearInterval(this.hardCloseInterval);
            //         }
            // }, 5000);
            this.pingTimeout = false;
        }, 2000);
    }

    async send(action, msg = false) {

        if (!this.socket || this.socket.readyState != this.socket.OPEN)
            return;

        let message = {
            'action': action,
            'data': msg
        };

        this.socket.send(JSON.stringify(message));

        // await saveDebug(">>> send " + message.action + " : " + JSON.stringify(message.data));
    }

    async onmessage(event) {

        const message = JSON.parse(event.data);
        if (!message)
            return;

        if (message.action && this.actions[message.action]) {
            this.actions[message.action](message.data);
        }

        // await saveDebug("<<< onmessage " + message.action + " : " + JSON.stringify(message.data));

        if (this.pingTimeout)
            clearTimeout(this.pingTimeout);
    }

    onopen() {

        this.send('auth', {
            token: this.token,
            coords: locationMgr.coords,
            id: this.id
        });
        GlobalVars.wsConnection = true;
        $('.avatar').addClass('connected');
    }

    onclose(event) {
        // console.log('onclose');
        GlobalVars.wsConnection = false;
        GlobalVars.wsAuthorized = false;
        // clearInterval(this.hardCloseInterval);

        if (event.wasClean) {
            //    console.log('Clean disconnect');
        } else {
            //   console.log('Connection lost')
        }
        $('.avatar').removeClass('connected');
        //  console.log('Code: ' + event.code + ' error: ' + event.reason);
        const self = this;
        // console.log('eClosed');
        // alert('reconnect');
        setTimeout(async function () {
            // console.log('connect');
            await self.connect();

        }, 1000);
    }

    onerror(error) {
        // console.log("Socket error " + error.message);
        this.disconnect();
    }

    async connect() {

        // await saveDebug("Try to connect");

        if (this.disableConnection) {
            // await saveDebug("disableConnection - exit");
            return;
        }

        if (this.socket && (this.socket.readyState == this.socket.OPEN || this.socket.readyState == this.socket.CONNECTING)) {
            // console.log('Already connected');
            // await saveDebug("Already connected - exit, "+this.socket.readyState);
            return;
        }

        this.token = await getToken();
        const socket_url = game.config.ws_url;
        try {
            this.socket = new WebSocket(socket_url);
        } catch (e) {
            // await saveDebug("Ws connection error");
            console.log('Ws connection error');
        }

        this.socket.onopen = this.onopen;
        this.socket.onclose = this.onclose;
        this.socket.onmessage = this.onmessage;
        this.socket.onerror = this.onerror;

        // await saveDebug("Connected");

    }

}

export default new Socket();
